<template>
  <div class="relative bg-gray-50 rounded-xl p-6 border overflow-hidden">
    <dt>
      <div class="absolute bg-blue-500 rounded-md w-12 h-12 flex text-white">
        <i :class="icon" class="m-auto text-lg"></i>
      </div>
      <div class="absolute top-7 right-6 w-12">

          <div class="vtoggle">
              <input class="vtoggle-input" type="checkbox" v-model="enabled" @change="statChanged(filter,enabled)"/>
              <div class="vtoggle-bg"></div>
              <div class="vtoggle-switch">
                  <div class="vtoggle-switch-figure"></div>
                  <div class="vtoggle-switch-figureAlt"></div>
              </div>
          </div>

      </div>
      <p class="ml-16 text-sm font-medium text-gray-500 truncate" v-text="label"></p>
    </dt>
    <dd class="ml-16 flex items-baseline">
      <p class="text-2xl font-semibold text-gray-900" v-text="value"></p>
    </dd>
  </div>
</template>

<script>
export default {
    props: {
      value: null,
      label: String,
      icon: String,
      filter: String
  },
  data: function() {
      return {
          enabled: true
      }
  },
  methods : {
      statChanged: function (filter,enabled) {
          this.$emit('afp-stat-changed', {filter:filter,enabled:enabled});
      }
  },
  emits: [
      "afp-stat-changed"
  ]
}
</script>

<style lang="scss">
.vtoggle {
  transform: rotate(270deg);
  position: relative;
  display: inline-block;
  width: 80px;
  height: 40px;
  padding: 4px;
  border-radius: 20px;
}

.vtoggle:before,
.vtoggle:after {
  content: '';
  display: table;
}

.vtoggle:after {
  clear: both;
}

.vtoggle-bg {
  position: absolute;
  top: -4px;
  left: -4px;
  width: 100%;
  height: 100%;
  background-color: #EEEEEE;
  border-radius: 20px;
  border: 2px solid #CCCCCC;
  transition: all .1s cubic-bezier(0.250, 0.460, 0.450, 0.940);
}

.vtoggle-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid red;
  border-radius: 20px;
  z-index: 2;
  opacity: 0;
}

.vtoggle-switch {
  position: relative;
  width: 25px;
  height: 25px;
  margin-left: 38px;
  border-color: #CCCCCC;
  background-color: #CCCCCC;
  border-radius: 50%;
  transition: all .1s cubic-bezier(0.250, 0.460, 0.450, 0.940);
}

/////////////////////////////////////////////////
// Night State
/////////////////////////////////////////////////
.vtoggle-input:checked ~ .vtoggle-switch {
  margin-left: 0;
  background-color: rgb(59, 130, 246);
  border: 2px solid rgb(59, 130, 246);

}

.vtoggle-input:checked ~ .vtoggle-bg {
}

.vtoggle-input:checked ~ .vtoggle-switch .vtoggle-switch-figure {
  margin-left: 40px;
  opacity: 0;
  transform: scale(0.1);
}

.vtoggle-input:checked ~ .vtoggle-switch .vtoggle-switch-figureAlt {
  transform: scale(1);
}
</style>